export default "__VITE_ASSET__wwd7RAC6__"